import { CmsObjectWithDefault } from '@components/Cms/types';

export type PasswordHelpersCmsKey = 'CapsLockWarning';

export const PasswordHelpersCmsWithDefault: CmsObjectWithDefault<PasswordHelpersCmsKey> = {
    CapsLockWarning: {
        cmsId: 287921,
        defaultTranslation: 'Caps Lock is on',
    },
};
